export const DATA_HOOKS = {
  membershipButton: 'membership button',
};
